import {
  sanitization
} from "./chunk-4ZAFAYNX.mjs";

// src/internal/components/help-center-panel/help-center-article/HOC/withSanitize.tsx
import { jsx } from "react/jsx-runtime";
var withSanitize = (Component) => {
  const WrappedComponent = ({ article, ...rest }) => {
    if (!article.body)
      return null;
    return /* @__PURE__ */ jsx(
      Component,
      {
        article: {
          ...article,
          body: sanitization(article.body)
        },
        ...rest
      }
    );
  };
  WrappedComponent.displayName = `withSanitize(${(Component == null ? void 0 : Component.displayName) || (Component == null ? void 0 : Component.name)})`;
  return WrappedComponent;
};
var withSanitize_default = withSanitize;

export {
  withSanitize_default
};
